import { formatDate } from '@angular/common';
import { Component, Input } from '@angular/core';
import * as pdfMake from 'pdfmake/build/pdfmake';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import { firstValueFrom } from 'rxjs';
import { UserI } from 'src/app/interfaces/user.interface';
import { LodService } from 'src/app/services/lod-1/lod-1.service';
//import { LodService } from 'src/app/services/lod-1/lod-1.service';
import {
  checkIcon,
  imgToBase64,
  minusIcon,
  notCheckIcon,
} from 'src/app/tools/tools';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-pdf-button',
  templateUrl: './pdf-button.component.html',
  styleUrls: ['./pdf-button.component.css'],
})
export class PdfButtonComponent {
  constructor(private readonly lodService: LodService) { }

  @Input() form!: any;

  async getOne(id: string) {
    try {
      const form = await firstValueFrom(this.lodService.getOneForm(id));
      if (form)
        form.attach.forEach((a: any) => {
          a.attachment = `${environment.imagesUrl}comments/${a.attachment}`;
        });
      return form;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  async pdf() {
    if (typeof this.form === 'string') {
      this.form = await this.getOne(this.form);
    }
    if (this.form) {
      const pM = pdfMake;
      pM.fonts = {
        // download default Roboto font from cdnjs.com
        Roboto: {
          normal:
            'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
          bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
          italics:
            'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
          bolditalics:
            'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf',
        },
      };
      const content = this.content();
      const lobName = this.form?.lob?.name ?? 'Sin LOB';

      const dd: TDocumentDefinitions = {
        // header: {
        //   text: `Registro de Auditoria LOD1 #${this.form.id_visible} - ${this.form.type ? this.form.type.name : 'Sin definir'
        //     }`,
        //   margin: 20,
        //   alignment: 'right',
        // },
        footer: function (currentPage: any, pageCount: any) {
          return [
            {
              text: `Shell HSE | ${lobName} | página: ${currentPage}`,
              margin: 20,
              alignment: 'center',
            },
          ];
        },
        content: await content,

        //STYLES
        styles: {
          header: {
            fontSize: 22,
            bold: true,
          },
          footer: {
            margin: 2,
          },
          responseStyle: {
            italics: true,
            lineHeight: 1,
            margin: 2,
          },
          responseTitle: {
            bold: true,
            margin: [0, 15],
            alignment: 'center',
            fontSize: 18,
          },
          questionTitle: {
            bold: true,
            margin: [0, 8],
            alignment: 'left',
            fontSize: 14,
          },

          //Comment Styles
          commentStyle: {
            margin: [0, 2],
            bold: true,
            decoration: 'underline',
          },
          commentDataStyle: {
            margin: [14, 3],
            alignment: 'justify',
          },
        },
      };
      pdfMake.createPdf(dd, undefined, pdfMake.fonts).open();
    }
  }

  async content() {
    const brokenImageLogo = await imgToBase64(
      environment.webUrl + 'assets/img/logo/broken-image.png'
    );
    const pdfImageLogo = await imgToBase64(
      environment.webUrl + 'assets/img/logo/pdf-file.png'
    );
    const content: any[] = [];
    //* Cabecera principal:
    content.push(
      {
        table: {
          widths: ['100%'],
          body: [
            [
              {
                columns: [
                  {
                    image: await imgToBase64(
                      environment.webUrl + 'assets/img/login/logo2.png'
                    ),
                    width: 40,
                    margin: 4,
                  },
                  {
                    //* Definimos el tipo de auditoría y el id
                    text: `Registro de Auditoria LOD1 #${this.form.id_visible
                      } - ${this.form.type ? this.form.type.name : 'Sin definir'
                      }`,
                    bold: true,
                    alignment: 'center',
                    margin: [0, 15, 0, 0],
                  },
                ],
              },
            ],
          ],
        },
        margin: [0, 0, 0, 15],
      },
      {
        table: {
          widths: ['50%', '*'],
          body: [
            [
              {
                columns: [
                  {
                    text: 'Cargado por:',
                    bold: true,
                    width: 'auto',
                  },
                  {
                    text: this.form.upload_user
                      ? this.form.upload_user.full_name
                      : 'Sin definir',
                    alignment: 'left',
                    margin: [4, 0],
                  },
                ],
                margin: [2, 5],
              },
              {
                columns: [
                  {
                    text: 'Fecha de carga:',
                    bold: true,
                    width: 'auto',
                  },
                  {
                    text: formatDate(
                      this.form.upload_date,
                      'dd/MM/yyyy HH:mm',
                      'en-US'
                    ),
                    alignment: 'left',
                    margin: [4, 0],
                  },
                ],
                margin: [2, 5],
              },
            ],
            [
              {
                columns: [
                  {
                    text: 'Empresa:',
                    bold: true,
                    width: 'auto',
                  },
                  {
                    text: this.form.contractor
                      ? this.form.contractor.name
                      : 'Sin definir',
                    alignment: 'left',
                    margin: [4, 0],
                  },
                ],
                colSpan: 2,
                margin: [2, 5],
              },
            ],
            [
              {
                columns: [
                  {
                    text: 'Area:',
                    bold: true,
                    width: 'auto',
                  },
                  {
                    text: this.form.area ? this.form.area.name : 'Sin definir',
                    alignment: 'left',
                    margin: [4, 0],
                  },
                ],
                colSpan: 2,
                margin: [2, 5],
              },
            ],
            [
              {
                columns: [
                  {
                    text: 'Inspector:',
                    bold: true,
                    width: 'auto',
                  },
                  {
                    text: this.form.upload_user ?
                      this.form.upload_user.full_name : '',
                    alignment: 'left',
                    margin: [4, 0],
                  },
                ],
                colSpan: 2,
                margin: [2, 5],
              },
            ],
            [
              {
                columns: [
                  {
                    text: 'Acompañantes:',
                    bold: true,
                    width: 'auto',
                  },
                  {
                    text: this.setInspectores(
                      this.form.acompaniantes
                    )?this.setInspectores(
                      this.form.acompaniantes
                    ):'No contiene participantes Extras',
                    alignment: 'left',
                    margin: [4, 0],
                  },
                ],
                colSpan: 2,
                margin: [2, 5],
              },
            ],
            [
              {
                columns: [
                  {
                    text: 'Fecha:',
                    bold: true,
                    width: 'auto',
                  },
                  {
                    text: formatDate(this.form.date, 'dd/MM/yyyy', 'en-US'),
                    alignment: 'left',
                    margin: [4, 0],
                  },
                ],
                colSpan: 2,
                margin: [2, 5],
              },
            ],
          ],
        },
      },
      {
        text: 'Preguntas',
        style: 'responseTitle',
      }
    );
    //* Recorremos los títulos del formulario principal:
    for (const title of this.form.answer) {
      //* Empezamos por el título
      let cTitle = title.name;
      for (const sub of title.subtitle) {
        //* Si el subtitulo es diferente de nulo o vacío:
        if (sub.name || sub.name !== '') cTitle = cTitle + ' - ' + sub.name;
        content.push({
          text: cTitle,
          style: 'questionTitle',
        }); //* Primer push, el título
        //* Recorremos el apartado de preguntas:
        for (const que of sub.question) {
          let q = {
            columns: [
              {
                //* Seteamos el ícono para mostrar
                svg: que.answer[0]
                  ? que.answer[0].answer === -1
                    ? notCheckIcon
                    : que.answer[0].answer === 1
                      ? checkIcon
                      : minusIcon
                  : minusIcon,
                fit: [15, 15],
                style: 'responseStyle',
                width: 16, //TODO Ver si el width se adapta al 100%
              },
              {
                text: que.question,
                style: 'responseStyle',
              },
            ],
          };
          //* Pusheamos la pregunta con su respuesta
          content.push(q);
          if (que.answer[0]) {
            //* Seteamos el comentario, en caso que exista
            if (que.answer[0].comment) {
              const aCommentTitle = {
                text: 'Comentario',
                style: 'commentStyle',
              };
              content.push(aCommentTitle);
              const aComment = {
                text: que.answer[0].comment,
                style: 'commentDataStyle',
              };
              content.push(aComment);
            }
            //* En caso que existan los desvíos
            if (que.answer[0].detour.length > 0) {
              for (const [index, d] of que.answer[0].detour.entries()) {
                //* Título del desvío
                const dTitle = {
                  columns: [
                    {
                      text: `Desvío #${index + 1}`,
                      bold: true,
                      width: 'auto',
                    },
                    {
                      text: d.open === 1 ? '(Abierto)' : '(Cerrado)',
                      alignment: 'right',
                      margin: [2, 0],
                      color: d.open === 1 ? 'red' : 'green',
                    },
                  ],
                  margin: [0, 5, 0, 8],
                };
                content.push(dTitle);
                //* Tabla principal del desvío
                //* Creamos el body principal
                const tBody = [];
                tBody.push(
                  [
                    {
                      columns: [
                        {
                          text: 'Responsable:',
                          bold: true,
                          width: 'auto',
                        },
                        {
                          text: d.detour_responsable.full_name,
                          alignment: 'left',
                          margin: [4, 0],
                        },
                      ],
                      margin: 2,
                    },
                    {
                      columns: [
                        {
                          text: 'Fecha de carga:',
                          bold: true,
                          width: 'auto',
                        },
                        {
                          text: formatDate(
                            d.upload_date_time,
                            'dd/MM/yyyy HH:mm',
                            'en-US'
                          ),
                          alignment: 'left',
                          margin: [4, 0],
                        },
                      ],
                      margin: 2,
                    },
                  ],
                  [
                    {
                      columns: [
                        {
                          text: 'Riesgo:',
                          bold: true,
                          width: 'auto',
                        },
                        {
                          text: d.risk.name,
                          alignment: 'left',
                          margin: [4, 0],
                        },
                      ],
                      margin: 2,
                    },
                    {
                      columns: [
                        {
                          text: 'Fecha de vencimiento:',
                          bold: true,
                          width: 'auto',
                        },
                        {
                          text: formatDate(
                            d.expire_date,
                            'dd/MM/yyyy',
                            'en-US'
                          ),
                          alignment: 'left',
                          margin: [4, 0],
                        },
                      ],
                      margin: 2,
                    },
                  ],
                  [
                    {
                      columns: [
                        {
                          text: 'Descripción:',
                          bold: true,
                          width: 'auto',
                        },
                        {
                          text: d.description,
                          alignment: 'left',
                          margin: [4, 0],
                        },
                      ],
                      colSpan: 2,
                      margin: 2,
                    },
                  ],
                  [
                    {
                      columns: [
                        {
                          text: 'Acción recomendada:',
                          bold: true,
                          width: 'auto',
                        },
                        {
                          text: d.recommended_action,
                          alignment: 'left',
                          margin: [4, 0],
                        },
                      ],
                      colSpan: 2,
                      margin: 2,
                    },
                  ]
                );
                const att = [];
                //* Y pusheamos las imágenes
                for (const attach of d.attach) {
                  att.push([
                    {
                      columns: [
                        {
                          // if you specify width, image will scale proportionally
                          // image: attach.attachment ?? brokenImageLogo,
                          //! Vamos a parar las imágenes como URL
                          image: attach.attachment.endsWith('.pdf')
                            ? pdfImageLogo // Usa el ícono de PDF si el archivo es un PDF
                            : (await imgToBase64(`${attach.attachment}`)) ?? brokenImageLogo,

                          width: 120,
                          alignment: 'center',
                          margin: 4,
                          link: attach.attachment.endsWith('.pdf')
                            ? attach.attachment // Enlace directo al archivo PDF
                            : null, // Si no es PDF, no se incluye el enlace
                        },
                        {
                          text: attach.description,
                          alignment: 'left',
                          margin: [0, 40],
                        },
                      ],
                      colSpan: 2,
                      margin: 2,
                    },
                  ]);
                }
                //* Juntamos ambos array
                const all = [...tBody, ...att];
                const dTable = {
                  table: {
                    widths: ['50%', '*'],
                    body: all,
                  },
                };
                content.push(dTable);
                if (d.discharge.length > 0) {
                  for (const [index, disc] of d.discharge.entries()) {
                    const tDischarge = {
                      columns: [
                        {
                          text: 'Descargo #' + (index + 1),
                          bold: true,
                          width: 'auto',
                        },
                        {
                          text: `- ${disc.upload_user
                            ? disc.upload_user.full_name
                            : 'Sin definir'
                            } | Fecha: ${formatDate(
                              disc.date,
                              'dd/MM/yyyy HH:mm',
                              'en-US'
                            )} hs`,
                          margin: [2, 0],
                          width: 'auto',
                        },
                        {
                          text:
                            disc.state === 0
                              ? '(Pendiente)'
                              : disc.state === 1
                                ? '(Aceptado)'
                                : '(Rechazado)',
                          alignment: 'right',
                          margin: [2, 0],
                          color:
                            disc.state === 0
                              ? 'orange'
                              : disc.state === 1
                                ? 'green'
                                : 'red',
                          width: '*',
                        },
                      ],
                      margin: [0, 5, 0, 8],
                    };
                    const tReason = {
                      text: disc.reason,
                      alignment: 'left',
                      margin: 0,
                    };
                    content.push(tDischarge);
                    content.push(tReason);
                    //* Imágenes
                    for (const a of disc.attach) {
                      const attach = {
                        columns: [
                          {
                            // if you specify width, image will scale proportionally
                            //image: a.attachment ?? brokenImageLogo,
                            //! Vamos a parar las imágenes como URL
                            image: a.attachment.endsWith('.pdf')
                              ? pdfImageLogo // Usa el ícono de PDF si el archivo es un PDF

                              : (await imgToBase64(`${a.attachment}`)) ?? brokenImageLogo,
                            width: 120,
                            alignment: 'center',
                            margin: 4,

                            link: a.attachment.endsWith('.pdf')
                              ? a.attachment // Enlace directo al archivo PDF
                              : null, // Si no es PDF, no se incluye el enlace
                          },
                          {
                            text: a.description ?? 'Sin comentarios',
                            alignment: 'left',
                            margin: [0, 40],
                          },
                        ],
                        // colSpan: 2,
                        margin: 2,
                      };
                      content.push(attach);
                    }

                    //! Solo los que no son pendientes tienen una respuesta
                    if (disc.state !== 0) {
                      //* Respuesta del descargo:
                      const rUser = {
                        columns: [
                          {
                            text: 'Respuesta por:',
                            bold: true,
                            width: 'auto',
                          },
                          {
                            text: `${disc.answer_user
                              ? disc.answer_user.full_name
                              : 'Sin definir'
                              } | Fecha: ${disc.answer_date
                                ? formatDate(
                                  disc.answer_date,
                                  'dd/MM/yyyy',
                                  'en-US'
                                )
                                : 'Sin definir'
                              }`,
                            margin: [2, 0],
                            alignment: 'right',
                            width: 'auto',
                          },
                        ],
                        margin: [0, 5, 0, 8],
                      };
                      content.push(rUser);
                      const rText = {
                        text: disc.answer ? disc.answer : 'Sin definir',
                        alignment: 'right',
                        margin: 0,
                      };
                      content.push(rText);
                    }
                  }
                }
                if (d.detour_close.length > 0) {
                  for (const close of d.detour_close) {
                    const dClose = {
                      columns: [
                        {
                          text: 'Fundamento de cierre:',
                          bold: true,
                          width: 'auto',
                        },
                        {
                          text: close.reason,
                          margin: [2, 0],
                          width: 'auto',
                        },
                      ],
                      margin: [0, 5, 0, 8],
                    };
                    content.push(dClose);
                  }
                }
              }
            }
          }

          //* Footer de la pregunta
          const qFooter = {
            canvas: [
              {
                type: 'line',
                x1: 0,
                y1: 0,
                x2: 520,
                y2: 0,
                lineWidth: 1,
                lineColor: que.answer[0]
                  ? que.answer[0].answer === -1
                    ? 'red'
                    : que.answer[0].answer === 1
                      ? 'green'
                      : 'orange'
                  : 'orange',
              },
            ],
            margin: [0, 4, 0, 10],
          };
          content.push(qFooter);
        }
      }
    }
    //* Los desvíos generales
    if (this.form.detour.length > 0) {
      for (const [index, det] of this.form.detour.entries()) {
        const tText = {
          text: 'Desvío general #' + (index + 1),
          style: 'responseTitle',
        };
        content.push(tText);
        const tBody: any[] = [];
        tBody.push([
          {
            columns: [
              {
                text: 'Responsable:',
                bold: true,
                width: 'auto',
              },
              {
                text: det.detour_responsable
                  ? det.detour_responsable.full_name
                  : 'Sin definir',
                alignment: 'left',
                margin: [4, 0],
              },
            ],
            margin: 2,
          },
          {
            columns: [
              {
                text: 'Fecha de carga:',
                bold: true,
                width: 'auto',
              },
              {
                text: formatDate(
                  det.upload_date_time,
                  'dd/MM/yyyy HH:mm',
                  'en-US'
                ),
                alignment: 'left',
                margin: [4, 0],
              },
            ],
            margin: 2,
          },
        ]);
        tBody.push([
          {
            columns: [
              {
                text: 'Riesgo:',
                bold: true,
                width: 'auto',
              },
              {
                text: det.risk ? det.risk.name : 'Sin definir',
                alignment: 'left',
                margin: [4, 0],
              },
            ],
            margin: 2,
          },
          {
            columns: [
              {
                text: 'Fecha de vencimiento:',
                bold: true,
                width: 'auto',
              },
              {
                text: formatDate(det.expire_date, 'dd/MM/yyyy', 'en-US'),
                alignment: 'left',
                margin: [4, 0],
              },
            ],
            margin: 2,
          },
        ]);
        tBody.push([
          {
            columns: [
              {
                text: 'Descripción:',
                bold: true,
                width: 'auto',
              },
              {
                text: det.description,
                alignment: 'left',
                margin: [4, 0],
              },
            ],
            colSpan: 2,
            margin: 2,
          },
        ]);
        tBody.push([
          {
            columns: [
              {
                text: 'Acción recomendada:',
                bold: true,
                width: 'auto',
              },
              {
                text: det.recommended_action,
                alignment: 'left',
                margin: [4, 0],
              },
            ],
            colSpan: 2,
            margin: 2,
          },
        ]);
        //* Para pushear los adjuntos:
        const att = [];

        //* Adjuntamos los adjuntos:
        for (let i = 0; i < det.attach.length; i += 2) {
          const row = [
            {
              columns: [
                {
                  image: det.attach[i].attachment.endsWith('.pdf')
                    ? pdfImageLogo // Usa el ícono de PDF si el archivo es un PDF
                    : (await imgToBase64(det.attach[i].attachment)) ?? brokenImageLogo,
                  width: 120,
                  alignment: 'center',
                  margin: [4, 4, 4, 4], // Usar arreglo para el margen

                  link: det.attach[i].attachment.endsWith('.pdf')
                    ? det.attach[i].attachment // Enlace directo al archivo PDF
                    : null, // Si no es PDF, no se incluye el enlace


                },
                {
                  text: det.attach[i].description ?? 'Sin comentarios',
                  alignment: 'left',
                  margin: [0, 40], // Usar arreglo para el margen
                },
              ],
              margin: [2, 2, 2, 2], // Arreglo para el margen
            },
          ];

          // Agregar el segundo adjunto en la misma fila si existe.
          if (det.attach[i + 1]) {
            row.push({
              columns: [
                {
                  image: det.attach[i + 1].attachment.endsWith('.pdf')
                    ? pdfImageLogo
                    : (await imgToBase64(det.attach[i + 1].attachment)) ?? brokenImageLogo,
                  width: 120,
                  alignment: 'center',
                  margin: [4, 4, 4, 4],

                  link: det.attach[i + 1].attachment.endsWith('.pdf')
                    ? det.attach[i + 1].attachment // Enlace directo al archivo PDF
                    : null, // Si no es PDF, no se incluye el enlace
                  // Arreglo para el margen
                },
                {
                  text: det.attach[i + 1].description ?? 'Sin comentarios',
                  alignment: 'left',
                  margin: [0, 40], // Arreglo para el margen
                },
              ],
              margin: [2, 2, 2, 2], // Arreglo para el margen
            });
          } else {
            // Agregar una columna vacía si no hay segundo adjunto.
            row.push({
              columns: [
                {
                  text: '', // Celda en blanco sin 'width'
                  alignment: 'center',
                  margin: [4, 4, 4, 4],
                },
                {
                  text: '', // Texto vacío para mantener estructura
                  alignment: 'left',
                  margin: [0, 40],
                },
              ],
              margin: [2, 2, 2, 2],
            });
          }

          att.push(row);
        }

        // Agregar las filas de adjuntos a tBody
        if (att.length > 0) tBody.push(...att);

        const dTable = {
          table: {
            widths: ['50%', '*'],
            body: tBody,
          },
        };

        content.push(dTable);

        //* Ahora los descargos:
        for (const [index, dis] of det.discharge.entries()) {
          const tDischarge = {
            columns: [
              {
                text: 'Descargo #' + (index + 1),
                bold: true,
                width: 'auto',
              },
              {
                text: `- ${dis.upload_user ? dis.upload_user.full_name : 'Sin definir'
                  } | Fecha: ${formatDate(
                    dis.date,
                    'dd/MM/yyyy HH:mm',
                    'en-US'
                  )}`,
                margin: [2, 0],
                width: 'auto',
              },
              {
                text:
                  dis.state === 1
                    ? '(Aceptado)'
                    : dis.state === 0
                      ? '(Pendiente)'
                      : '(Rechazado)',
                alignment: 'right',
                margin: [2, 0],
                color:
                  dis.state === 1
                    ? 'green'
                    : dis.state === 0
                      ? 'orange'
                      : 'red',
                width: '*',
              },
            ],
            margin: [0, 5, 0, 8],
          };

          for (const a of dis.attach) {
            const tAttach = {
              columns: [
                {
                  //image: a.attachment,
                  image: a.attachment.endsWith('.pdf')
                    ? pdfImageLogo // Usa el ícono de PDF si el archivo es un PDF
                    : (await imgToBase64(a.attachment)) ?? brokenImageLogo,

                  width: 120,
                  alignment: 'center',
                  margin: 4,

                  link: a.attachment.endsWith('.pdf')
                    ? a.attachment // Enlace directo al archivo PDF
                    : null, // Si no es PDF, no se incluye el enlace
                },
                {
                  text: a.description,
                  alignment: 'left',
                  margin: [0, 40],
                },
              ],
              // colSpan: 2,
              margin: 2,
            };
            content.push(tAttach);
          }
          content.push(tDischarge);
          if (dis.answer) {
            const tResponse = {
              columns: [
                {
                  text: 'Respuesta por:',
                  bold: true,
                  width: 'auto',
                },
                {
                  text: `${dis.answer_user ? dis.answer_user.full_name : 'Sin definir'
                    } | Fecha: ${formatDate(
                      dis.answer_date,
                      'dd/MM/yyyy HH:mm',
                      'en-US'
                    )}`,
                  margin: [2, 0],
                  width: 'auto',
                },
              ],
              margin: [0, 5, 0, 8],
            };
            content.push(tResponse);
            //Response text
            const tText = {
              text: dis.answer,
              alignment: 'left',
              margin: 0,
            };
            content.push(tText);
          }
        }

        if (det.detour_close.length > 0) {
          const tClose = {
            columns: [
              {
                text: 'Fundamento de cierre:',
                bold: true,
                width: 'auto',
              },
              {
                text: det.detour_close[0].reason,
                margin: [2, 0],
                width: 'auto',
              },
            ],
            margin: [0, 5, 0, 8],
          };
          content.push(tClose);
        }
      }
    }

    //* Por último, los extras:
    content.push({
      text: 'Extras',
      style: 'responseTitle',
    });
    content.push({
      text: 'Adjuntos',
      bold: true,
      decoration: 'underline',
    });
    if (this.form.attach.length > 0) {
      for (const a of this.form.attach) {
        const tAttach = {
          // if you specify width, image will scale proportionally
          //image: a.attachment ?? brokenImageLogo,
          //! Vamos a parar las imágenes como URL
          image: a.attachment.endsWith('.pdf')
            ? pdfImageLogo // Usa el ícono de PDF si el archivo es un PDF
            : (await imgToBase64(a.attachment)) ?? brokenImageLogo,
          width: 120,
          alignment: 'center',
          margin: 4,
          link: a.attachment.endsWith('.pdf')
            ? a.attachment // Enlace directo al archivo PDF
            : null, // Si no es PDF, no se incluye el enlace
        };
        const tComment = {
          text: a.description,
          alignment: 'center',
        };
        content.push(tAttach);
        content.push(tComment);
      }
    } else {
      const tNoAttach = {
        text: 'Sin adjuntos disponibles',
        alignment: 'center',
      };
      content.push(tNoAttach);
    }
    const tExtra = {
      text: 'Comentarios extras:',
      bold: true,
      decoration: 'underline',
    };
    content.push(tExtra);
    const tExtraComment = {
      text: this.form.comments ?? 'Sin comentarios extras.',
      style: 'commentDataStyle',
    };
    content.push(tExtraComment);
    return content;
  }

  setInspectores(inspectores: UserI[]): string {
    let items = ''; // Inicializa como una cadena vacía
    if (inspectores.length > 0) {
      items = inspectores.map((i) => i.full_name).join(', ');
    }
    return items;
  }
}
